import { ChangeDetectionStrategy, ChangeDetectorRef, Component, NgZone } from '@angular/core';
import { BasePrintComponent } from '@common/classes/base-print.component';
import { ModalService } from '@common/services/modal.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-pcs-approval-print',
    templateUrl: './pcs-approval-print.component.html',
    styleUrls: ['./pcs-approval-print.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PcsApprovalPrintComponent extends BasePrintComponent {
    constructor(
        dialogService: ModalService,
        translateService: TranslateService,
        cdr: ChangeDetectorRef,
        ngZone: NgZone
    ) {
        super(dialogService, translateService, cdr, ngZone);
    }

    isWaitingForApproval(): boolean {
        const statusCode = this.model?.pcsApprovalMainData?.pcsApprovalStatusCode;
        return statusCode === 'WFA' || statusCode === '2ND_WFA' || statusCode === '3RD_WFA';
    }
}
